<template>
  <v-card class="mx-auto mt-4 rounded-card" elevation="4" max-width="800">
    
    <v-card-title class="font-weight-bold text-wrap">
      {{ this.name }}
    </v-card-title>
    <div class="container">
      <div class="container">
        <div class="row justify-content-start">
          <div class="ml-1">
            <v-icon>mdi-arrow-up-down-bold-outline</v-icon>
            <label> Caption: {{ this.caption }} </label>
          </div>
        </div>
      </div>
      <div class="row justify-content-start">
        <v-card-subtitle>  Demand Rate : {{ this.demandRate }} </v-card-subtitle>
      </div>
      <div class="row justify-content-start"> 
        <v-card-subtitle> Image: 
            <v-img :src="this.image" height="200px"></v-img>
         </v-card-subtitle>
        <v-card-subtitle>Date: {{ this.timestamp }} </v-card-subtitle>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    show: false,
    marker: "Mark as High",
  }),

  props: {
    name: {
      type: String,
      required: false,
    },
    timestamp: {
      type: String,
      required: false,
    },
    caption: {
      type: String,
      required: true,
    },
    demandRate: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
  },
};
</script>